export default "#define GLSLIFY 1\nuniform float uAlpha;\nuniform vec3 uColor;\n\nvoid main()\n{\n    gl_FragColor = vec4(uColor, uAlpha);\n}";